/**
 * Created by piotr.pozniak@thebeaverhead.com on 21/07/2025.
 */
import axios, { Axios } from "axios";
import AxiosConfig from "../AxiosConfig";

/**
 * Sends anonymous statistics about a widget interaction.
 * @param {string} widgetType
 * @param {string} widgetUUID
 * @param {string|null} itemID
 */
export function sendAnonymousStats(widgetType, widgetUUID, itemID) {
  if (AxiosConfig.isBuilder) {
    // Do not send stats in the builder context
    return;
  }
  const data = {
    widgetType,
    widgetUUID,
    itemID,
  };

  const queryString = new URLSearchParams(data).toString();

  const url = AxiosConfig.getEndpointAddress() + `/stats?${queryString}`;

  axios.get(url).catch((e) => {
    console.error("Error sending anonymous stats:", e);
  });
}
